import { merge } from "lodash";
import React from "react";
import { DEFAULT_TABLE_STYLES } from "../table/v2/tableStyles";
import { ThemeContext } from "./useThemeContext";
import { colorShade } from "./colors";
import { TMS_THEME } from "./theming";
export var Client;
(function (Client) {
    Client["Portal"] = "portal";
    Client["TMS"] = "tms";
})(Client || (Client = {}));
export const ThemeProvider = ({ brandedTable, children, client = Client.TMS, buttonStyles }) => (React.createElement(ThemeContext.Provider, { value: {
        brandedTable: getBrandedTableTheme(brandedTable),
        client,
        buttonStyles: getButtonStyles(buttonStyles),
    } }, children));
const getBrandedTableTheme = (brandedTable) => {
    if (brandedTable) {
        const brandedTheme = {
            header: {
                borderBottom: {
                    width: 1,
                    color: adjustColourForBorder(brandedTable),
                },
                borderLeft: {
                    width: 1,
                    color: adjustColourForBorder(brandedTable),
                },
                borderRight: {
                    width: 1,
                    color: adjustColourForBorder(brandedTable),
                },
                borderTop: {
                    width: 1,
                    color: adjustColourForBorder(brandedTable),
                },
                separator: {
                    width: 1,
                    color: adjustColourForBorder(brandedTable),
                },
                backgroundColor: brandedTable.backgroundColor,
                color: brandedTable.color,
            },
        };
        return merge({}, DEFAULT_TABLE_STYLES, brandedTheme);
    }
};
const adjustColourForBorder = (brandedTable) => `${colorShade(brandedTable.backgroundColor, -50)}`;
const getButtonStyles = (buttonStyles) => {
    let definedButtonsStyles = {
        primary: {
            color: TMS_THEME.palette.primary.base.contrast,
            backgroundColor: TMS_THEME.palette.primary.base.color,
            borderRadius: buttonStyles?.primary?.borderRadius,
        },
        default: {
            color: TMS_THEME.palette.primary.base.color,
            backgroundColor: "transparent",
            borderRadius: buttonStyles?.primary?.borderRadius,
        },
    };
    if (buttonStyles?.primary) {
        definedButtonsStyles = merge({}, definedButtonsStyles, {
            primary: {
                color: buttonStyles?.primary?.color ??
                    TMS_THEME.palette.primary.base.contrast,
                backgroundColor: buttonStyles?.primary?.backgroundColor ??
                    TMS_THEME.palette.primary.base.color,
            },
        });
    }
    if (buttonStyles?.default) {
        definedButtonsStyles = merge({}, definedButtonsStyles, {
            default: { color: buttonStyles?.default?.color },
        });
    }
    return definedButtonsStyles;
};
